export default __webpack_public_path__ + "static/media/4.f6229a63.jpg";